// eslint-disable-next-line import/prefer-default-export
export const flightSeatAttributes = {
  INFANTS_ALLOWED: 'INFANTS_ALLOWED',
  CHILDREN_ALLOWED: 'CHILDREN_ALLOWED',
  HANDICAP_ACCESS: 'HANDICAP_ACCESS',
  AISLE: 'AISLE',
  ABSENT_SEAT: 'ABSENT_SEAT',
  EXIT_ROW: 'EXIT_ROW',
};

export const nonSeatAttributes = [
  flightSeatAttributes.AISLE,
  flightSeatAttributes.ABSENT_SEAT,
];



/** WEBPACK FOOTER **
 ** ./src/constants/flightSeats.js
 **/